<div class="spinner-wrapper">
  <mat-spinner></mat-spinner>
  <div class="states">
    @for (state of getStates(); track state; let index = $index) {
      <div [@outIn]="getAnimationState(index)"
      [class]="'state ' + getAnimationState(index)">{{state | translate}}</div>
    }
  </div>
</div>
